/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getUpdateAnalyticsFlowHelper } from '@jira/issue__analytics-update-events/src/getUpdateAnalyticsFlowHelper.tsx';
import { ASSIGNEE_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { AnalyticsAttributes } from '../../common/types/analytics/index.tsx';

const ACTIONS_TO_WATCH = ['unassign', 'assignToMe'];

// a way to set isCommandPaletteEditing to true when action is
// from issue shortcut registry
export const setEventAttribute = (attributes: AnalyticsAttributes): void => {
	if (
		attributes.actionCategory === 'issueActions' &&
		typeof attributes.action === 'string' &&
		ACTIONS_TO_WATCH.includes(attributes.action)
	) {
		getUpdateAnalyticsFlowHelper().setAttributes(ASSIGNEE_TYPE, {
			isCommandPaletteEditing: true,
		});
	}
};
